Ext.define('SA.TimeSeriesExportConfig', {
    extend: 'SA.ExportConfig',

    resource: 'data/location',

    async prepare() {
        var query = await this.model.getExportQuery(),
            {aggregates, fields: select, filter, sort, where: locationSeries} = query,
            transpose = !this.model.isTransposed();

        this.params = {aggregates, filter, locationSeries, select, sort, transpose};
        this.limitCheck = await SA.LimitCheck.getForLocations(this.params);
    }
});